import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStatusCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 22.5,
			height: 22.5,
			rx: 11.25,
			fill: "#6FC696"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 22.5,
			height: 22.5,
			rx: 11.25,
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7871 16.9961C10.5059 16.9961 10.2656 16.8711 10.0664 16.6211L7.03125 12.8242C6.95703 12.7344 6.90234 12.6465 6.86719 12.5605C6.83594 12.4746 6.82031 12.3867 6.82031 12.2969C6.82031 12.0938 6.88672 11.9258 7.01953 11.793C7.15625 11.6602 7.32812 11.5938 7.53516 11.5938C7.77344 11.5938 7.97461 11.7012 8.13867 11.916L10.7637 15.2852L15.8496 7.20508C15.9395 7.06836 16.0312 6.97266 16.125 6.91797C16.2188 6.85938 16.3398 6.83008 16.4883 6.83008C16.6914 6.83008 16.8574 6.89453 16.9863 7.02344C17.1152 7.14844 17.1797 7.3125 17.1797 7.51562C17.1797 7.59766 17.166 7.68164 17.1387 7.76758C17.1113 7.84961 17.0684 7.9375 17.0098 8.03125L11.502 16.6152C11.3301 16.8691 11.0918 16.9961 10.7871 16.9961Z",
			fill: "white"
		})
	]
});
export default SvgIconStatusCheck;
